import {
  Button,
  DatePicker,
  Input,
  Modal,
  Pagination,
  Select,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "wouter";
import { getQueryParams } from "../../utilities/getQueryParams";
import CommonAdminTable from "../components/commonTable";
import {
  StockAnalysisAPI,
  StockAnalysisExportAPI,
} from "../../redux/actions/adminActions/analysisActions";
const { Title } = Typography;
const StockAnalysis = () => {
  const columns = [
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      align: "center",
      render: (text) => {
        return text.toUpperCase();
      },
    },
    {
      title: "Item",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Punched(QTY)",
      dataIndex: "punched_qty",
      key: "punched_qty",
      align: "center",
    },
    {
      title: "Dispatched(QTY)",
      dataIndex: "dispatched_qty",
      key: "dispatched_qty",
      align: "center",
    },
    {
      title: "Difference(%)",
      dataIndex: "difference_percent",
      key: "difference_percent",
      align: "center",
    },
  ];
  // const dataSource = [
  //   {
  //     key: "1",
  //     sku: "AT033208901",
  //     title: "NTRL TUBE CLO ALU FOIL 32089-at033208901",
  //     punched_qty: 50,
  //     dispatched_qty: 40,
  //     difference_percent: 20, // (10/50)*100
  //   },
  //   {
  //     key: "2",
  //     sku: "AT033207601",
  //     title: "NTRL TUBE CLO ALU FOIL 32076-at033207601",
  //     punched_qty: 560,
  //     dispatched_qty: 500,
  //     difference_percent: 10.71,
  //   },
  //   {
  //     key: "3",
  //     sku: "AT033206001",
  //     title: "NTRL TUBE CLO ALU FOIL 32060-at033206001",
  //     punched_qty: 816,
  //     dispatched_qty: 700,
  //     difference_percent: 14.22,
  //   },
  //   {
  //     key: "4",
  //     sku: "AT033204801",
  //     title: "NTRL TUBE CLO ALU FOIL 32048-at033204801",
  //     punched_qty: 480,
  //     dispatched_qty: 400,
  //     difference_percent: 16.67,
  //   },
  //   {
  //     key: "5",
  //     sku: "AT031904201",
  //     title: "NTRL TUBE CLO ALU FOIL 19042-at031904201",
  //     punched_qty: 256,
  //     dispatched_qty: 200,
  //     difference_percent: 21.88,
  //   },
  //   {
  //     key: "6",
  //     sku: "AT031903201",
  //     title: "NTRL TUBE CLO ALU FOIL 19032-at031903201",
  //     punched_qty: 240,
  //     dispatched_qty: 180,
  //     difference_percent: 25,
  //   },
  //   {
  //     key: "7",
  //     sku: "AS06131225",
  //     title: "NBR SHEET CL O ALU F 13X1.2X25-as06131225",
  //     punched_qty: 51780,
  //     dispatched_qty: 48000,
  //     difference_percent: 7.3,
  //   },
  //   {
  //     key: "8",
  //     sku: "AT210600601",
  //     title: "A FLEX ECO CLASS 1 TUBES 06x06x1.83-at210600601",
  //     punched_qty: 743000,
  //     dispatched_qty: 700000,
  //     difference_percent: 5.79,
  //   },
  //   {
  //     key: "9",
  //     sku: "AT210601301",
  //     title: "A FLEX ECO CLASS 1 TUBES 06x13x1.83-at210601301",
  //     punched_qty: 504600,
  //     dispatched_qty: 450000,
  //     difference_percent: 10.82,
  //   },
  //   {
  //     key: "10",
  //     sku: "AT210601601",
  //     title: "A FLEX ECO CLASS 1 TUBES 06x16x1.83-at210601601",
  //     punched_qty: 130560,
  //     dispatched_qty: 120000,
  //     difference_percent: 8.09,
  //   },
  // ];
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Order Requests: ALP Shop";
  }, []);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalData, setTotalData] = useState(1);
  console.log("totalData: ", totalData);
  const [searchValue, setSearchValue] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const currentYear = dayjs();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const getCurrentQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    return Math.ceil(month / 3);
  };
  const [selectedQuarter, setSelectedQuarter] = useState(
    String(getCurrentQuarter()),
  );
  const [exportModal, setExportModal] = useState(false);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/analysis/stock-analysis?page=${page}`);
  };

  useEffect(() => {
    dispatch(
      StockAnalysisAPI({
        year: selectedYear.year(),
        quarter: selectedQuarter ?? 1,
        page: currentPage,
        perPage: 10,
      }),
    ).then((res) => {
      setTotalData(res?.payload?.data?.pagination?.total);
      setDataSource(res?.payload?.data?.data);
    });
  }, [dispatch, currentPage, selectedYear, selectedQuarter]);
  const exportData = () => {
    dispatch(
      StockAnalysisExportAPI({
        year: selectedYear.year(),
        quarter: selectedQuarter,
      }),
    )
      .then((res) => {
        console.log("res is: ", res);
        const csvData = res?.payload?.data;

        if (!csvData) {
          console.error("No data received");
          return;
        }

        // Create Blob
        const blob = new Blob([csvData], {
          type: "text/csv;charset=utf-8;",
        });

        // Create download URL
        const url = window.URL.createObjectURL(blob);

        // Create temporary link
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `stock-analysis-${res?.meta?.arg?.year}-quarter-${res?.meta?.arg?.quarter}.csv`,
        );

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.log(err);
      });
    setExportModal(false);
  };
  return (
    <>
      <div className="flex justify-between items-center">
        <Title level={2} className="text-left">
          Stocks Analysis
        </Title>
        <div className="flex gap-2 items-center">
          {/* <label className="font-semibold">Year:</label> */}
          <DatePicker
            picker="year"
            className="rounded-md"
            allowClear={false}
            placeholder="Year"
            value={selectedYear}
            onChange={(value) => setSelectedYear(value)}
          />
          <Select
            className="w-[150px] [&_.ant-select-selector]:rounded-md"
            //   style={{ borderRadius: "6px!important" }}
            allowClear
            placeholder="Quarter(optional)"
            value={selectedQuarter}
            onChange={(value) => setSelectedQuarter(value)}
            options={[
              { label: "Quarter 1", value: "1" },
              { label: "Quarter 2", value: "2" },
              { label: "Quarter 3", value: "3" },
              { label: "Quarter 4", value: "4" },
            ]}
          />
          <Button
            type="primary"
            className="rounded-md"
            onClick={() => setExportModal(true)}
          >
            EXPORT
          </Button>
        </div>
      </div>
      {/* <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div> */}
      <CommonAdminTable columns={columns} data={dataSource} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalData}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <Modal
        open={exportModal}
        onCancel={() => setExportModal(false)}
        onOk={exportData}
      >
        <div>
          <Title level={2} className="text-left">
            Stock Analysis
          </Title>
          <div className="flex gap-2 items-center">
            {/* <label className="font-semibold">Year:</label> */}
            <DatePicker
              picker="year"
              allowClear={false}
              className="rounded-md"
              placeholder="Year"
              onChange={(value) => setSelectedYear(value)}
            />
            <Select
              className="w-[150px] [&_.ant-select-selector]:rounded-md"
              //   style={{ borderRadius: "6px!important" }}
              allowClear
              placeholder="Quarter(optional)"
              // value={selectedQuarter}
              onChange={(value) => setSelectedQuarter(value)}
              options={[
                { label: "Quarter 1", value: "1" },
                { label: "Quarter 2", value: "2" },
                { label: "Quarter 3", value: "3" },
                { label: "Quarter 4", value: "4" },
              ]}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default StockAnalysis;
